import React, { useState } from "react";
import "./solutionSection.css";
import guardrailManagementImage from "../../images/solution-section-tabswitch-image-1.png";
import riskManagementImage from "../../images/solution-section-tabswitch-image-2.svg";
import qualityEnhancementImage from "../../images/solution-section-tabswitch-image-3.jpeg";
import ScrollReveal from "../scrollReveal/scrollReveal";

export default function SolutionSection() {
  const [activeTab, setActiveTab] = useState(1);
  const handleTabSwitch = (index) => {
    setActiveTab(index);
  };
  return (
    <ScrollReveal>
      <section className="solution-section" id="one">
        <div className="container">
          <div className="section-wrapper">
            <div className="section-heading">
              <div className="heading-tag">
                <span>SOLUTIONS</span>
              </div>
              <div className="heading-description">
                <div>
                  <h2>Ensuring AI Excellence:</h2>
                  <span>
                    Safe AI Systems for Assurance, Quality and Risk Management
                  </span>
                </div>
                <p>
                  Unlock advanced systems that fortify AI with reliability and
                  security, seamlessly integrating trust, guardrails, and risk
                  management
                </p>
              </div>
            </div>
            <div className="solution-tab-switch-wrapper">
              <div className="solution-tab-switch-body">
                <div
                  className={`solution-tab-switch-content ${
                    activeTab === 1 ? "active" : ""
                  }`}
                >
                  <div className="tab-switch-image">
                    <img src={guardrailManagementImage} alt="solutions-image" />
                  </div>
                </div>
                <div
                  className={`solution-tab-switch-content ${
                    activeTab === 2 ? "active" : ""
                  }`}
                >
                  <div className="tab-switch-image">
                    <img src={riskManagementImage} alt="solutions-image" />
                  </div>
                </div>
                <div
                  className={`solution-tab-switch-content ${
                    activeTab === 3 ? "active" : ""
                  }`}
                >
                  <div className="tab-switch-image">
                    <img src={qualityEnhancementImage} alt="solutions-image" />
                  </div>
                </div>
                {/* <div
                  className={`solution-tab-switch-content ${
                    activeTab === 4 ? "active" : ""
                  }`}
                >
                  <div className="tab-switch-image">
                    <img src={riskManagementImage} alt="solutions-image" />
                  </div>
                </div> */}
              </div>
              <div className="tab-links-container">
                <div
                  className={`${activeTab === 1 ? "active" : ""}`}
                  onClick={() => handleTabSwitch(1)}
                >
                  <h3>Guardrails for AI</h3>
                  <p>
                    Empower ethical and secure AI operations with built-in
                    guardrails for safe decision-making.
                  </p>
                </div>
                <div
                  className={`${activeTab === 2 ? "active" : ""}`}
                  onClick={() => handleTabSwitch(2)}
                >
                  <h3>Risk Under Control</h3>
                  <p>
                    Proactively identify and address risks to ensure dependable
                    and responsible AI solutions.
                  </p>
                </div>
                <div
                  className={`${activeTab === 3 ? "active" : ""}`}
                  onClick={() => handleTabSwitch(3)}
                >
                  <h3>Quality Redefined</h3>
                  <p>
                    Achieve superior performance through rigorous quality
                    assurance for consistent and accurate outcomes.
                  </p>
                </div>
                {/* <div
                  className={`${activeTab === 4 ? "active" : ""}`}
                  onClick={() => handleTabSwitch(4)}
                >
                  <h3>Trust in Action</h3>
                  <p>
                    Quantify and enhance AI reliability with AI trust scores
                    that ensure transparency and confidence.
                  </p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </section>
    </ScrollReveal>
  );
}
